import { CrudApi, DownloadableCrudApi, PaginatedCrudApi, PostsApiBase, SortableCrudApi } from '@/common/api/types'

const getBaseCrudApi = (url: string): CrudApi => {
    return {
        index: `api/${url}`,
        store: `api/${url}`,
        update (id: number): string {
            return `api/${url}/${id}`
        },
        remove (id: number): string {
            return `api/${url}/${id}`
        }
    }
}

const getPaginatedCrudApi = (url: string): PaginatedCrudApi => {
    return {
        index (page: number): string {
            return `api/${url}?page=${page}`
        },
        store: `api/${url}`,
        update (id: number): string {
            return `api/${url}/${id}`
        },
        remove (id: number): string {
            return `api/${url}/${id}`
        }
    }
}

const getBasePostsApi = (url: string): PostsApiBase => {
    return {
        forApproval: `api/${url}/for-approval`,
        store: `api/${url}`,
        approve (id: number): string {
            return `api/${url}/${id}/approve`
        },
        edit (id: number): string {
            return `api/${url}/${id}/edit`
        },
        myEntries (page: number, asCreator: boolean): string {
            return asCreator
                ? `api/${url}/my-entries?page=${page}&as_creator`
                : `api/${url}/my-entries?page=${page}`
        },
        remove (id: number): string {
            return `api/${url}/${id}`
        },
        update (id: number): string {
            return `api/${url}/${id}`
        }
    }
}

const getDownloadableCrudApi = (url: string): DownloadableCrudApi => {
    return {
        download (id: number): string {
            return `api/${url}/${id}/download`
        },
        ...getBaseCrudApi(url)
    }
}

const getSortableCrudApi = (url: string): SortableCrudApi => {
    return {
        sort: `api/${url}/sort`,
        ...getBaseCrudApi(url)
    }
}

export { getBaseCrudApi, getBasePostsApi, getDownloadableCrudApi, getPaginatedCrudApi, getSortableCrudApi }
